import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { storeUnits } from "../../../Store/TemplateStore/template.action";
import {
  SETTING_OPTIONS,
  Language_Currency_Mapping,
  Currency_Conversion_Mapping,
  Default_Currency_Rate,
} from "./settingsOptions.config";

import DupontRadio from "../../../components/DupontRadio";
import DupontButton from "../../../components/DupontButton";
import DupontDialog from "../../../components/DupontDialog";
import InputBox from "../../../components/InputBox";
import { TextFieldValidator } from "../../../components/InputBox/TextFieldValidator";
import PopoverText from "../../../components/PopoverText";
import InfoIconGreen from "../../../assets/info-icon-green.svg";

import "./index.scss";

const Settings = React.forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();

  const {
    flow,
    pressure,
    feed_suspended,
    filtrate_suspended,
    temperature,
    flux,
    volume,
    currency,
    mass,
    conversion_rate,
    appLanguage,
  } = useSelector((state) => state);

  const [defaultSettingState, setDefaultSettingState] = useState({
    flow,
    pressure,
    feed_suspended,
    filtrate_suspended,
    temperature,
    flux,
    volume,
    currency,
    mass,
    conversion_rate,
  });
  const { disabled } = props;
  const [openCurrencyConvertor, setOpenCurrencyConvertor] = useState(false);
  const [user_enter_conversion_rate, set_User_enter_conversion_rate] = useState(
    defaultSettingState.conversion_rate
  );
  const [currencyRateError, setCurrencyRateError] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [openFeedQuality, setOpenFeedQuality] = useState(false);
  const [user_feed_conversion_factor, set_User_feed_conversion_factor] =
    useState(defaultSettingState.feed_water_factor);
  const [feedConversionError, setFeedConversionError] = useState(false);
  const [openPermeateQuality, setOpenPermeateQuality] = useState(false);
  const [user_permeate_conversion_factor, set_User_permeate_conversion_factor] =
    useState(defaultSettingState.feed_water_permeate_factor);
  const [permeateConversionError, setPermeateConversionError] = useState(false);
  const settingOptions = SETTING_OPTIONS();
  const currencySymbols = {
    Yuan: "元/$",
    Euro: "€/$",
  };
  const currencyDisplay = currencySymbols[defaultSettingState.currency];

  const dispatch = useDispatch();

  const setConversionRate = (currency, value) => {
    let conversionRate = defaultSettingState.conversion_rate;
    if (value === "USD") conversionRate = 1;
    else if (currency !== value && value === "Yuan") {
      conversionRate =
        defaultSettingState.conversion_rate == 1 || 0.9
          ? 7.17
          : user_enter_conversion_rate;
      set_User_enter_conversion_rate(conversionRate);
    } else if (currency !== value && value === "Euro") {
      conversionRate =
        defaultSettingState.conversion_rate == 1 || 7.17
          ? 0.9
          : user_enter_conversion_rate;
      set_User_enter_conversion_rate(conversionRate);
    }
    return conversionRate;
  };

  useEffect(() => {
   
    let correctVolume = volume;
    if (flow === "m³/h" || flow === "m³/d") {
      correctVolume = "m³";
    } else if (flow === "gpm") {
      correctVolume = "kgal";
    }

    setDefaultSettingState({
      flow,
      pressure,
      feed_suspended,
      filtrate_suspended,
      temperature,
      flux,
      volume: correctVolume,
      currency,
      mass,
      conversion_rate,
      appLanguage,
    });
  }, [
    flow,
    pressure,
    feed_suspended,
    filtrate_suspended,
    temperature,
    flux,
    volume,
    currency,
    mass,
    conversion_rate,
    appLanguage,
  ]);

  // useEffect(() => {
  //   const lang = appLanguage === "en" ? "en-US" : appLanguage;
  //   if (lang !== i18n.language && !disabled) {
  //     let conversionRate = defaultSettingState.conversion_rate;
  //     const value = Language_Currency_Mapping[i18n.language];
  //     conversionRate = setConversionRate(currency, value);
  //     dispatch(
  //       storeUnits({
  //         ...defaultSettingState,
  //         ["currency"]: currency,
  //         ["conversion_rate"]: conversionRate,
  //       })
  //     );
  //     setDefaultSettingState({
  //       ...defaultSettingState,
  //       ["currency"]: Language_Currency_Mapping[i18n.language],
  //       ["conversion_rate"]: conversionRate,
  //     });
  //   }
  //   setInitialLoad(false);
  // }, [props.fileId]);

  // useEffect(() => {
  //   const lang = appLanguage === "en" ? "en-US" : appLanguage;
  //   if (lang !== i18n.language && !disabled) {
  //     let conversionRate = defaultSettingState.conversion_rate;
  //     const value = Language_Currency_Mapping[i18n.language];
  //     conversionRate = setConversionRate(currency, value);
  //     dispatch(
  //       storeUnits({
  //         ...defaultSettingState,
  //         ["currency"]: currency,
  //         ["conversion_rate"]: conversionRate,
  //       })
  //     );
  //     setDefaultSettingState({
  //       ...defaultSettingState,
  //       ["currency"]: Language_Currency_Mapping[i18n.language],
  //       ["conversion_rate"]: conversionRate,
  //     });
  //   }
  // }, [i18n.language, t]);

  const settingsInformation = () => {
    const settingInformation = {
      flow: defaultSettingState.flow,
      pressure: defaultSettingState.pressure,
      feed_suspended: defaultSettingState.feed_suspended,
      filtrate_suspended: defaultSettingState.filtrate_suspended,
      temperature: defaultSettingState.temperature,
      flux: defaultSettingState.flux,
      volume: defaultSettingState.volume,
      currency: defaultSettingState.currency,
      mass: defaultSettingState.mass,
      conversion_rate:
        defaultSettingState.currency === "USD"
          ? 1
          : defaultSettingState.conversion_rate,
    };
    dispatch(storeUnits(settingInformation));
  };

  React.useImperativeHandle(ref, () => ({ settingsInformation }));

  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    let updatedSettings = {
      ...defaultSettingState,
      [name]: value,
    };
    if (name === "flow") {
      if (value === "m³/h" || value === "m³/d") {
        updatedSettings.volume = "m³";
      } else if (value === "gpm") {
        updatedSettings.volume = "kgal";
      }
    }

    let conversionRate = defaultSettingState.conversion_rate;
    if (name === "currency") {
      conversionRate = setConversionRate(currency, value);
    }

    setDefaultSettingState({
      ...updatedSettings,
      ["conversion_rate"]: conversionRate,
    });
    dispatch(
      storeUnits({ ...updatedSettings, ["conversion_rate"]: conversionRate })
    );
  };

  const onProceedClicked = async (value) => {
    setOpenCurrencyConvertor(false);
    setCurrencyRateError("");

    if (value === "CONFIRM") {
      dispatch(
        storeUnits({
          ...defaultSettingState,
          conversion_rate: user_enter_conversion_rate,
        })
      );
      setDefaultSettingState({
        ...defaultSettingState,
        ["conversion_rate"]: user_enter_conversion_rate,
      });
    } else {
      set_User_enter_conversion_rate(defaultSettingState.conversion_rate);
    }
  };

  const handleConversionRateChange = (value) => {
    setCurrencyRateError("");
    if (value <= 0) {
      setCurrencyRateError(t("settingStrings.rateError"));
    }
    set_User_enter_conversion_rate(value);
  };

  return (
    <div className="lightGrayBorder section-container">
      <div
        className="headerTealText"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>
          {t("settingStrings.settings")}
          <span style={{ color: "red" }}>*</span>
        </span>
        <PopoverText
          descriptor={<img src={InfoIconGreen} alt="icon" />}
          descriptionText={props.descriptionText}
        />
      </div>
      <div className="grid-container-settings">
        {Object.keys(settingOptions).map((key, index) => (
          <div className="grid-item-settings " key={key}>
            <div className="checkbox-label">{t(`settingStrings.${key}`)}</div>

            {Object.values(settingOptions[key].options).map((option) => (
              <div
                key={option}
                onChange={handleOptionChange}
                className="checkbox-container"
              >
                <DupontRadio
                  text={option}
                  checked={defaultSettingState[key] === option}
                  value={option}
                  name={key}
                  disabled={key === "volume" ? true : disabled}
                />
              </div>
            ))}
            {key === "currency" && (
              <DupontButton
                key="currencyButton"
                type="tertiary"
                customClass="button-tertiary-custom-width font-size-14  margin-top-10"
                onClick={() => setOpenCurrencyConvertor(!openCurrencyConvertor)}
                disabled={disabled || defaultSettingState["currency"] === "USD"}
              >
                {t("settingStrings.rate")}
              </DupontButton>
            )}
          </div>
        ))}
        {openCurrencyConvertor && (
          <DupontDialog
            open={openCurrencyConvertor}
            title={t("settingStrings.enterRate")}
            cancelBtnText={t("ValueStrings.cancel")}
            confirmBtnText={t("ValueStrings.confirm")}
            onClose={onProceedClicked}
            confirmDisabled={!user_enter_conversion_rate || currencyRateError}
          >
            <div>
              <div className="flex-ai-center ">
                <InputBox
                  value={user_enter_conversion_rate}
                  placeholder={t("settingStrings.rate")}
                  maxLength={10}
                  onChange={handleConversionRateChange}
                  customClass={"text-left width100"}
                  validator={TextFieldValidator.NUMBER_TWO_DECIMAL}
                  errorMsg={currencyRateError}
                />
                <span className="bodyMainHeadingText">{currencyDisplay}</span>
              </div>

              <div className="descriptionText text-left margin-top-10">
                {t("settingStrings.rateNote")}
              </div>
            </div>
          </DupontDialog>
        )}
      </div>
    </div>
  );
});

export default Settings;
